import React, { Component, Fragment } from 'react'
import { connect } from 'react-redux'
import axios from 'axios'
import { Panel, Button, OverlayTrigger, Popover, Glyphicon } from 'react-bootstrap'

import { handleErrorFetchingData } from '../../functions/errorHandling'

import EditUpdate from './EditUpdate'

class Update extends Component {

  state = {
    editMode: false,
    expanded: false,
    deletingUpdate: false,
  }

  toggleEditMode = () => this.setState({ editMode: !this.state.editMode })

  toggleExpand = () => this.setState({ expanded: !this.state.expanded, editMode: false })

  formatDate = (date) => {
    date = date.split('T')[0].split('-')
    const year = date[0]
    const month = date[1]
    const day = date[2]
    return `${month}-${day}-${year}`
  }

  handleDelete = () => {
    const { url } = this.props.update
    const { deletingUpdate } = this.state

    if (deletingUpdate) {
      return
    }

    this.setState({ deletingUpdate: true })

    axios({
      method: "DELETE",
      url,
      headers: {"Authorization": "Bearer " + localStorage.getItem("token")},
    })
    .then(response => {
      this.props.deleteUpdate(url)
    })
    .catch(error => {
      const message = "There was an error deleting the update."
      handleErrorFetchingData(error, message)
    })
  }

  render () {
    const { update, currentUser } = this.props
    const { editMode, expanded, deletingUpdate } = this.state

    const creator = update.created_by
    let postedByClassName = null
    let currentUserIsCreator = creator.id === currentUser.pk
    if (currentUserIsCreator) {
      postedByClassName = 'current-user'
    }

    let postedBy = `${creator.first_name} ${creator.last_name}`

    const overlay = (
      <Popover
        id="deleteUpdatePopover"
        title="Delete Update"
      >
        <p>
          Are you sure you want to delete this update?
        </p>
        <br/>
        <p>
          This action is <strong>irreversible</strong>.
        </p>
        <br/>
        <center>
          <Button
            bsStyle="danger"
            onClick={this.handleDelete}
            disabled={deletingUpdate}
          >
            {deletingUpdate ?
              <Glyphicon
                glyph='refresh'
                style={{minWidth: '40px'}}
                className='rotate-btn'
              />
              :
              'Delete'
            }
          </Button>
        </center>
      </Popover>
    )

    return (
      <Panel
        id="Update"
        expanded={expanded}
        onToggle={this.toggleExpand}
      >
        <Panel.Heading style={{backgroundColor: 'white'}}>
          <Panel.Title toggle>
            {update.name}
          </Panel.Title>
        </Panel.Heading>
        <Panel.Collapse>
          <Panel.Body>
            {editMode ?
              <EditUpdate
                update={update}
                toggleEditMode={this.toggleEditMode}
                editUpdate={this.props.editUpdate}
              />
              :
              <Fragment>
                <div dangerouslySetInnerHTML={{__html: update.body}}>
                </div>
                <br/>
                {currentUserIsCreator ?
                  <span style={{float: 'right'}}>
                    <Button
                      style={{margin: '0 10px 0 0'}}
                      onClick={deletingUpdate ? () => null : this.toggleEditMode}
                      disabled={deletingUpdate}
                    >
                      Edit
                    </Button>
                    <OverlayTrigger
                      rootClose
                      trigger="click"
                      overlay={overlay}
                      placement="top"
                    >
                      <Button
                        style={{margin: '0 0 0 10px'}}
                        bsStyle='danger'
                      >
                        Delete
                      </Button>
                    </OverlayTrigger>
                  </span>
                  :
                  null
                }
                <div className="posted-by-text">
                  By: <span className={postedByClassName}>
                    {postedBy}
                  </span>
                  <br/>
                  {update.created_date ? this.formatDate(update.created_date) : ''}
                </div>
              </Fragment>
            }
          </Panel.Body>
        </Panel.Collapse>
      </Panel>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    currentUser: state.manageLogin.user,
  }
}

export default connect(mapStateToProps)(Update)



// WEBPACK FOOTER //
// ./src/reuseable-components/updates/Update.js